
import { GoogleGenAI, Type } from "@google/genai";
import { AIEstimate, Unit, Transaction } from "../types";

export const getAIEstimate = async (description: string): Promise<AIEstimate> => {
  if (!process.env.API_KEY) {
    throw new Error("Gemini API Key is missing.");
  }
  
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  
  const response = await ai.models.generateContent({
    model: "gemini-3-pro-preview",
    contents: `Estimate mobile home repair costs for: ${description}`,
    config: {
      systemInstruction: "You are an expert mobile home repair contractor. Provide a realistic cost breakdown in USD for a mobile home repair. Output must be valid JSON.",
      responseMimeType: "application/json",
      responseSchema: {
        type: Type.OBJECT,
        properties: {
          parts: { type: Type.NUMBER },
          labor: { type: Type.NUMBER },
          justification: { type: Type.STRING }
        },
        required: ["parts", "labor", "justification"]
      }
    }
  });
  
  const text = response.text;
  if (!text) throw new Error("No response text from Gemini API.");
  return JSON.parse(text) as AIEstimate;
};
